export enum Role {
    SuperAdmin = "SuperAdmin",
    Admin = 'Admin',
    Client = "Client",
    Operator = 'Operator',
    GoSiteIT = "GoSiteIT"
}
export enum RoleId {
  SuperAdmin = 1,
  Admin = 2,
  ARSME = 7,
  Operator = 3,
  QC = 4,
  GoSiteIT = 8
}
